import { Action } from '@ngrx/store';
import { Toast, NotificationData } from '@models/*';

export class AddToast implements Action {
    readonly type = UiActionTypes.ADD_TOAST;

    constructor(public payload: Toast) {
    }
}

export class DismissToast implements Action {
    readonly type = UiActionTypes.DISMISS_TOAST;

    constructor(public payload: number) {
    }
}

export class AddGalleryData implements Action {
    readonly type = UiActionTypes.ADD_GALLERY_DATA;

    constructor(public payload: { photos: string[], startIndex: number }) {
    }
}

export class EmptyGalleryData implements Action {
    readonly type = UiActionTypes.EMPTY_GALLERY_DATA;
}

export class AddNotification implements Action {
    readonly type = UiActionTypes.ADD_NOTIFICATION;

    constructor(public payload: { notification: NotificationData, duringOffline: boolean }) {
    }
}

export class ClearNotification implements Action {
    readonly type = UiActionTypes.CLEAR_NOTIFICATION;

    constructor(public payload: number) {
    }
}

export class ClearAllNotifications implements Action {
    readonly type = UiActionTypes.CLEAR_ALL_NOTIFICATIONS;
}

export class OpenNotification implements Action {
    readonly type = UiActionTypes.OPEN_NOTIFICATION;

    constructor(public payload: number) {
    }
}

export class HideNotifications implements Action {
    readonly type = UiActionTypes.HIDE_NOTIFICATIONS;
}

export class CheckNotificationOnExit implements Action {
    readonly type = UiActionTypes.CHECK_NOTIFICATION_ON_EXIT;
}

export class CancelUpdatedTourAnimation implements Action {
    readonly type = UiActionTypes.CANCEL_UPDATED_TOUR_ANIMATION;

    constructor(public payload: number) {
    }
}

export enum UiActionTypes {
    'ADD_TOAST' = 'ADD_TOAST',
    'DISMISS_TOAST' = 'DISMISS_TOAST',
    'ADD_GALLERY_DATA' = 'ADD_GALLERY_DATA',
    'EMPTY_GALLERY_DATA' = 'EMPTY_GALLERY_DATA',
    'ADD_NOTIFICATION' = 'ADD_NOTIFICATION',
    'CLEAR_NOTIFICATION' = 'CLEAR_NOTIFICATION',
    'CLEAR_ALL_NOTIFICATIONS' = 'CLEAR_ALL_NOTIFICATIONS',
    'OPEN_NOTIFICATION' = 'OPEN_NOTIFICATION',
    'HIDE_NOTIFICATIONS' = 'HIDE_NOTIFICATIONS',
    'CHECK_NOTIFICATION_ON_EXIT' = 'CHECK_NOTIFICATION_ON_EXIT',
    'CANCEL_UPDATED_TOUR_ANIMATION' = 'CANCEL_UPDATED_TOUR_ANIMATION'
}

export type UiActions = AddToast | DismissToast | AddGalleryData | EmptyGalleryData |
    AddNotification | ClearNotification | ClearAllNotifications | OpenNotification | HideNotifications |
    CheckNotificationOnExit | CancelUpdatedTourAnimation;
